/**
 * 全角数字を半角数字に変換し、数字以外の文字を除去する。
 * NFKC 正規化（互換等価分解 + 正規合成）で全角→半角を一括変換する。
 *
 * @example
 * convertToHalfWidthNumbers('１２３')     // → '123'
 * convertToHalfWidthNumbers('abc１２３')  // → '123'
 * convertToHalfWidthNumbers('-123')       // → '123'（マイナスは除去される）
 */
export const convertToHalfWidthNumbers = (input: string): string =>
  input.normalize('NFKC').replace(/[^0-9]/g, '')

/**
 * 全角数字を半角数字に変換し、先頭のマイナス記号のみ保持する。
 * マイナス記号を受け付ける数値フィールドの入力値正規化に使う。
 *
 * 入力途中の '-' 単独の状態（数字がまだない）は、表示を維持するために
 * '-' をそのまま返す（parseInt すると NaN になり、フォーム値は更新されない）。
 *
 * @example
 * convertToHalfWidthNumbersWithSign('－１２３')  // → '-123'
 * convertToHalfWidthNumbersWithSign('-123')      // → '-123'
 * convertToHalfWidthNumbersWithSign('123')       // → '123'
 * convertToHalfWidthNumbersWithSign('-')         // → '-'（入力途中、表示を維持）
 * convertToHalfWidthNumbersWithSign('－')        // → '-'（全角マイナス単独）
 */
export const convertToHalfWidthNumbersWithSign = (input: string): string => {
  // NFKC 正規化で全角文字（数字・マイナス記号など）を半角に一括変換する
  // さらに長音符「ー」(U+30FC) を '-' に変換する
  // 日本語IMEで '-' を打つと「ー」が入力されることがあるため
  const normalized = input.normalize('NFKC').replace(/ー/g, '-')

  const negative = normalized.startsWith('-')
  const digits = normalized.replace(/[^0-9]/g, '')

  if (!negative) return digits

  // マイナス記号があるが数字がまだない場合は入力途中として '-' を返す
  if (digits.length === 0) return '-'

  return `-${digits}`
}
